import React from 'react';
import styled from '@emotion/styled';
import { Link } from '../../Link';

//css
const ListWrapper = styled.dl(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: theme.fontSizes.lg,
    marginBottom: theme.space[2],
}));

const ListDt = styled.dt(({ theme }) => ({
    textAlign: 'left',
    color: theme.colors.grey100,
    fontSize: theme.fontSizes.xs,
}));

const ListDd = styled.dd(({ theme }) => ({
    color: theme.colors.black,
    textAlign: 'right',
    fontSize: theme.fontSizes.xs,
}));

const LinkSpec = styled(Link)(({ theme }) => ({
    color: theme.colors.black,
    textAlign: 'right',
    fontSize: theme.fontSizes.xs,
    textDecoration: 'underline',
    '&:hover': {
        color: theme.colors.black,
    },
}));

//Type of Specification Array
export type SummarySpecificationProps = {
    specifications?: ProductSpecs[];
};

export type ProductSpecs = {
    name?: string;
    text?: string;
    url?: string;
    target?: string;
    id?: string;
    itemProp?: string;
};

const replaceSemi = (text: string) => text?.replace(/;/g, ', ');
// Only add space if the comma is a list divider and NOT a unit value
const addSpaceAfterComma = (text: string) =>
    text
        .replace(new RegExp(/(\D),(\D)/, 'g'), '$1, $2')
        .replace(new RegExp(/(\d),(\D)/, 'g'), '$1, $2')
        .replace(new RegExp(/(\D),(\d)/, 'g'), '$1, $2');

const formatDisplayValue = (text?: string) => {
    if (!text) return '';

    if (text.includes(';')) {
        return replaceSemi(text);
    }

    if (text.includes(',')) {
        return addSpaceAfterComma(text);
    }

    return text;
};

export const SummarySpecifications = ({ specifications }: SummarySpecificationProps) => {
    return (
        <>
            {specifications?.map((item) => (
                <ListWrapper key={item?.id || item?.name}>
                    <ListDt>{item.name}</ListDt>
                    <ListDd itemProp={item.itemProp}>
                        {item.url ? (
                            <LinkSpec
                                {...item}
                                title={formatDisplayValue(item.text)}
                                href={item.url}
                            >
                                {formatDisplayValue(item.text)}
                            </LinkSpec>
                        ) : (
                            formatDisplayValue(item.text)
                        )}
                    </ListDd>
                </ListWrapper>
            ))}
        </>
    );
};
